import { render, staticRenderFns } from "./PictureTeaserWidget.vue?vue&type=template&id=2084abbc&"
import script from "./PictureTeaserWidget.vue?vue&type=script&lang=ts&"
export * from "./PictureTeaserWidget.vue?vue&type=script&lang=ts&"
import style0 from "./PictureTeaserWidget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports